import { render, staticRenderFns } from "./ModalEditInvoiceFooter.vue?vue&type=template&id=2595ef90"
import script from "./ModalEditInvoiceFooter.vue?vue&type=script&lang=js"
export * from "./ModalEditInvoiceFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports